// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"209":"component---src-templates-dumpsters-kpp-pages-js","684":"cada2cc6","774":"framework"}[chunkId] || chunkId) + "-" + {"209":"65eb4c15b5eb016de344","212":"058caf1c3ff10b8c549b","589":"e5755b5cf428fee68086","684":"97eb806b08c089bceb66","774":"64fb867057913ead4b67"}[chunkId] + ".js";
};